


























import { config } from '@/config';
import Vue from 'vue';
const chatHeader = Vue.extend({
    props: ["isFullScreen", "agentIdentity", "chatHeaderTxt", "agentImg"],
    data() {
        return {
            openSelectLang: false,
        };
    },
    computed: {
        profileId() {
            return this.$vstore.settings.state.preferenceSettings.profileId;
        },
        channelId() {
            return this.$vstore.settings.state.preferenceSettings.channelId;
        },
        profileName() {
            return this.$vstore.settings.state.preferenceSettings.profile;
        },
        token() {
            return this.$vstore.settings.state.preferenceSettings.token;
        },
        closeButton() {
            return this.$vstore.settings.state.preferenceSettings.closeButton;
        },
        enableUserChooseLanguage() {
            return this.$vstore.settings.state.profileSettings.enableUserChooseLanguage;
        }
    },
    methods: {
        closeChatWindow() {
            this.$emit('closeWindow');
        },
        maxMinWindow() {
            window.open(window.location.origin + '/webchat/chatChannel.html#?profileId=' + this.profileId + '&token=' + this.token + '&channelId=' + this.channelId + '&closeButton=false', 'Tactful -' + this.profileName + ',resizable,height=736,width=616');
        },
        toggleSelectLangView() {
            this.openSelectLang = !this.openSelectLang;
            this.$emit('toggleSelectLangView', this.openSelectLang);
        }

    }
});
export default chatHeader;
